import { FC, ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { fontSizes } from "~/utils/theme";

const { md } = fontSizes;

interface Props {
  children: ReactNode;
  lgHeading: string;
  smHeading: string;
}

export const Chunk: FC<Props> = ({ smHeading, lgHeading, children }) => (
  <Flex
    align="center"
    direction="column"
    justify="center"
    mb={{ base: "0", md: 12 }}
    maxW={{ base: "20rem", md: "27rem" }}
    w="100%"
  >
    <Text
      color="fg-on-accent"
      fontFamily="Moderat Mono"
      fontWeight="bold"
      textTransform="uppercase"
    >
      {smHeading}
    </Text>
    <Flex align="center" direction="column" h="100%" w="100%">
      <Text
        color="fg-on-accent"
        fontSize={md}
        fontWeight="bold"
        mb={{ base: 4 }}
      >
        {lgHeading}
      </Text>
      {children}
    </Flex>
  </Flex>
);
